<template>
	<div class="detail">
		<div style="position:fixed;top:0;left:0;z-index:100;" class="yt_title">
        <a href="/"> <img class="yl_home" src="../assets/shouye.png" alt=""></a>
    </div>
		<div class="content" v-if="show">
			<iframe :src="'https://xhncloud.voc.com.cn/portal/news/show?id='+this.$route.params.tid" frameborder="0" id="iframe" scrolling="auto"></iframe>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	const moment = require('moment')
	require('moment/locale/zh-cn')
	Vue.use(require('vue-moment'), {
	    moment
	})
	Vue.moment().locale();
	let Base64 = require('js-base64').Base64;
	import matomo_fn from '../plugins/matomo'
	import {Dialog} from 'vant'
	export default{
		data(){
			return{
				show:false,
				title:'',
				org_id:0
			}
		},
		methods:{
		  toHome(){
        this.$router.push('/')
      },
			toLinks(){
				this.osUrl();
			},
      getData(webname){
		    this.$http.get(this.baseUrl+'/v1/news/show?appid='+this.appid+'&tid='+this.$route.params.tid).then((res)=>{
          	if(res.data.statecode==1){
				document.title = res.data.data.title+'-'+document.title+'-'+webname;
				this.title = res.data.data.title;
				this.show = true;
				let arr = [
					{key:'WAP',value:'WAP'},
					{key:'screen',value:'news_detail'},
					{key:'news_id',value:this.$route.params.tid},
					{key:'class_id',value:res.data.data.ClassID},
					{key:'editor_id',value:res.data.data.add_authorid},
				]
				matomo_fn(arr,'永兴新闻网详情页面')
				// var _paq = window._paq = window._paq || [];
				// /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
				// _paq.push(['setCustomVariable', 1, "channel_id", "WAP", "page"]);
				// _paq.push(['setCustomVariable', 2, "screen", "news_detail", "page"]);
				// _paq.push(['setCustomVariable', 3, "news_id", this.$route.params.tid, "page"]);
				// _paq.push(['setCustomVariable', 4, "class_id", res.data.data.ClassID, "page"]);
				// _paq.push(['setCustomVariable', 5, "editor_id", res.data.data.add_authorid, "page"]);
				// _paq.push(['trackPageView']);
				// _paq.push(['enableLinkTracking']);
				// var org_id = this.org_id;
				// (function() {
				// 	var u="https://click-xhncloud.voc.com.cn/";
				// 	_paq.push(['setTrackerUrl', u+'matomo.php']);
				// 	_paq.push(['setSiteId', org_id]);
				// 	var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
				// 	g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
				// })();
          }else{
            Dialog.alert({message:res.data.message}).then((rr)=>{
              this.toHome();
            })
          }
			  });
      }
		},
		 mounted() {
		  this.appid = localStorage.getItem('appid')
		  this.org_id = localStorage.getItem('org_id')
		  var webname = localStorage.getItem('webname')
      if(this.$route.params.tid==undefined){
        Dialog.alert({message:"新闻id不能为空"}).then((rr)=>{
              this.toHome();
            })
      }
      if(!this.appid){
          this.$http.get(this.baseUrl+'/v1/app/site?appid='+this.appid+"&url="+window.location.host).then((res)=>{if(res.data.statecode==1){
              if(res.data.data.app_id!=undefined){
                 webname = res.data.data.webname;
                 var appid = res.data.data.app_id;
                 var logo = res.data.data.logo;
                 this.org_id = res.data.data.org_id;
                 this.appid = appid;
                 localStorage.setItem("webname",webname)
                 localStorage.setItem("appid",appid)
                 localStorage.setItem("logo",logo)
				 localStorage.setItem("org_id",res.data.data.org_id);
              }else{
                Dialog.alert({message:"appid不存在"})
              }
          }else{
            Dialog.alert({message:res.data.message})
          }
        })
      }
      this.getData(webname)
		} 
	}
</script>
<style>
.newsContent .img{
	width: 100%;
	height: 100%;
	display: block;
	margin: 10Px auto;
	vertical-align: middle;
	margin-bottom: 20Px;
}
</style>
<style scoped>
.detail{
	overflow: hidden;
}
    .yt_title{
        width: 100%;
        height:110px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        font-size: 46px;
        color: #fff;
        background-color:#e80214;
        text-align: center;
        line-height: 46px;
    }
    .yt_title>a .yl_home{
        width: 38px;
        height: 39px;
        position: absolute;
        top: 50%;
        margin-top: -18.5px;
        left: 36px;
    }

.de_do{
	display: flex;
    align-items: center;
}

.van-button__text{
	line-height: 40Px;
	font-weight: 500;
	font-size: 18Px;
}

.content{
	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	width: 100%;
	height: 100vh;
	padding: 1.22rem 0 0;
	box-sizing: border-box; 
}
 .content>iframe{
	width: 100%;
	height: 100%;
} 
.container{
	margin-top: 40Px
}
.title{
	font-size: 24Px;
	line-height: 30Px;
	text-align: left;
	font-weight: bold;
}
.message{
	font-size: 12Px;
	text-align: center;
	margin:20Px 0px;
	color: #888;
}
.message span:last-child{
	margin-left: 10Px;
}
.newsContent{
	font-size: 18Px;
	line-height: 26Px;
	text-indent: 2em;
	text-align: justify!important;
}
.newsContent>p{
	font-size: 18Px;
	line-height: 26Px;
	text-indent: 2em;
	margin:16Px 0;
}
p{
	text-align: justify!important;
}
</style>
